module.exports = __webpack_public_path__ + "lib/2ihs-7qw.svg";